const IDENTITY_TYPE_OPTS = [
  { text: 'MyKad (NRIC)', value: 1, tin_code: 'NRIC' },
  { text: 'Passport', value: 2, tin_code: 'PASSPORT' },
  { text: 'Military / Police', value: 3, tin_code: 'ARMY' },
  { text: 'Company Registration Number', value: 4, tin_code: 'BRN' },
];
export default IDENTITY_TYPE_OPTS;

export const IDENTITY_TYPE_NRIC = 1;
export const IDENTITY_TYPE_PASSPORT = 2;
export const IDENTITY_TYPE_MILITARY = 3;
export const IDENTITY_TYPE_BRN = 4;
export const IDENTITY_TYPE_PRESET = 6;



// WEBPACK FOOTER //
// ./src/constants/defaultIdentityTypeOpts.js